<template>
  <span>
    <slot name="activator" :on="{ click }">
      <VBtn dark color="green darken-1" @click="click">
        {{ $t('continue') }}
      </VBtn>
    </slot>

    <VDialog
      v-model="dialog"
      v-bind="$attrs"
    >
      <VCard class="pa-5">
        <div class="title mb-3">
          <slot name="title">
            {{ title }}
          </slot>
        </div>

        <div v-if="$slots.description || description" class="mb-3">
          <slot name="description">
            {{ description }}
          </slot>
        </div>

        <div class="text-right">
          <slot name="buttons" :cancel="cancel" :confirm="confirm">
            <VBtn
              color="success"
              outlined
              :height="40"
              class="mt-1"
              @click="cancel"
            >
              {{ cancelText || $t('cancel') }}
            </VBtn>
            <VBtn color="success" class="ml-2 mt-1" @click="confirm">
              {{ confirmText || $t('confirm') }}
            </VBtn>
          </slot>
        </div>
      </VCard>
    </VDialog>
  </span>
</template>

<script>
export default {
  name: 'Confirm',
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    condition: {
      type: Boolean,
      default: true,
    },
    cancelText: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    showDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    click() {
      if (this.condition) {
        this.showDialog();
      } else {
        this.confirm();
      }
    },
    confirm() {
      this.$emit('confirmed');
      this.closeDialog();
    },
    cancel() {
      this.$emit('canceled');
      this.closeDialog();
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  continue: Continue
  cancel: Cancel
  confirm: Confirm
</i18n>

<i18n locale="ru" lang="yaml">
  continue: Продолжить
  cancel: Отмена
  confirm: Подтвердить
</i18n>
